const CheckIcon = () => (
  <svg className="shrink-0 w-5 h-5" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10 18C14.4153 18 18 14.4153 18 10C18 5.58468 14.4153 2 10 2C5.58468 2 2 5.58468 2 10C2 14.4153 5.58468 18 10 18V18M13.707 8.707C14.086 8.31462 14.0806 7.69092 13.6948 7.30518C13.3091 6.91945 12.6854 6.91403 12.293 7.293L9 10.586L7.707 9.293C7.31462 8.91403 6.69092 8.91945 6.30518 9.30518C5.91945 9.69092 5.91403 10.3146 6.293 10.707L8.293 12.707C8.6835 13.0974 9.3165 13.0974 9.707 12.707L13.707 8.707V8.707" fill="#86EFAC" />
  </svg>
);

const solutions = [
  {
    title: "AI-Powered Prioritization",
    points: ["Risk scoring (01-00)", "Smart workqueue", "Recommended next actions"],
    icon: (
     <svg className="shrink-0 w-8 h-8 relative overflow-visible" style={{ aspectRatio: 1 }} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 6H30V8H17V6Z" fill="white" />
        <path d="M17 12H27V14H17V12Z" fill="white" />
        <path d="M17 18H30V20H17V18Z" fill="white" />
        <path d="M17 24H27V26H17V24Z" fill="white" />
        <path d="M11.59 13.41L8 9.83L4.41 13.42L3 12L8 7L13 12L11.59 13.41Z" fill="white" />
        <path d="M11.59 18.5881L8 22.1681L4.41 18.5781L3 19.9981L8 24.9981L13 19.9981L11.59 18.5881Z" fill="white" />
      </svg>

    ),
  },
  {
    title: "Omnichannel Outreach",
    points: ["SMS, Email, WhatsApp API", "Cloud Telephony & IVR", "Compliance built-in"],
    icon: (
   <svg className="shrink-0 w-8 h-8 relative overflow-visible" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_446_628)">
          <path d="M13 26H11C7.1 26 4 22.9 4 19V17H6V19C6 21.8 8.2 24 11 24H13V26Z" fill="white" />
          <path d="M18 18H28C29.1 18 30 18.9 30 20V26C30 27.1 29.1 28 28 28H25.6L23.9 31L22.2 30L24.5 26H28V20H18V26H21V28H18C16.9 28 16 27.1 16 26V20C16 18.9 16.9 18 18 18Z" fill="white" />
          <path d="M28 14H26V12C26 9.2 23.8 7 21 7H17V5H21C24.9 5 28 8.1 28 12V14Z" fill="white" />
          <path d="M2 11H8V13H2V11Z" fill="white" />
          <path d="M2 7H14V9H2V7Z" fill="white" />
          <path d="M2 3H14V5H2V3Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_446_628">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>

    ),
  },
  {
    title: "Real-Time Visibility",
    points: ["Live dashboard", "Portfolio aging analysis", "Collection performance tracking"],
    icon: (
    <svg className="shrink-0 w-8 h-8 relative overflow-visible" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_446_656)">
    <path
      d="M30.9396 15.66C29.7634 12.6176 27.7216 9.98662 25.0664 8.09209C22.4112 6.19756 19.2591 5.12257 15.9996 5C12.7401 5.12257 9.58796 6.19756 6.93278 8.09209C4.27759 9.98662 2.23574 12.6176 1.05957 15.66C0.980142 15.8797 0.980142 16.1203 1.05957 16.34C2.23574 19.3824 4.27759 22.0134 6.93278 23.9079C9.58796 25.8024 12.7401 26.8774 15.9996 27C19.2591 26.8774 22.4112 25.8024 25.0664 23.9079C27.7216 22.0134 29.7634 19.3824 30.9396 16.34C31.019 16.1203 31.019 15.8797 30.9396 15.66ZM15.9996 25C10.6996 25 5.09957 21.07 3.06957 16C5.09957 10.93 10.6996 7 15.9996 7C21.2996 7 26.8996 10.93 28.9296 16C26.8996 21.07 21.2996 25 15.9996 25Z"
      fill="white"
    />
    <path
      d="M16 10C14.8133 10 13.6533 10.3519 12.6666 11.0112C11.6799 11.6705 10.9109 12.6075 10.4567 13.7039C10.0026 14.8003 9.88378 16.0067 10.1153 17.1705C10.3468 18.3344 10.9182 19.4035 11.7574 20.2426C12.5965 21.0818 13.6656 21.6532 14.8295 21.8847C15.9933 22.1162 17.1997 21.9974 18.2961 21.5433C19.3925 21.0892 20.3295 20.3201 20.9888 19.3334C21.6481 18.3467 22 17.1867 22 16C22 14.4087 21.3679 12.8826 20.2426 11.7574C19.1174 10.6321 17.5913 10 16 10ZM16 20C15.2089 20 14.4355 19.7654 13.7777 19.3259C13.1199 18.8864 12.6072 18.2616 12.3045 17.5307C12.0017 16.7998 11.9225 15.9956 12.0769 15.2196C12.2312 14.4437 12.6122 13.731 13.1716 13.1716C13.731 12.6122 14.4437 12.2312 15.2196 12.0769C15.9956 11.9225 16.7998 12.0017 17.5307 12.3045C18.2616 12.6072 18.8864 13.1199 19.3259 13.7777C19.7654 14.4355 20 15.2089 20 16C20 17.0609 19.5786 18.0783 18.8284 18.8284C18.0783 19.5786 17.0609 20 16 20Z"
      fill="white"
    />
  </g>
  <defs>
    <clipPath id="clip0_446_656">
      <rect width="32" height="32" fill="white" />
    </clipPath>
  </defs>
</svg>
    ),
  },
];

export default function SolutionSection() {
  return (
    <section className="bg-[#0f172a] py-24 px-5 md:px-20 overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col gap-12">
        {/* Header */}
        <div className="flex flex-col gap-4 items-center justify-center">
          <span
            className="text-[#e9d5ff] text-center font-semibold text-sm leading-5 uppercase"
            style={{ letterSpacing: "0.7px" }}
          >
            Complete Solution
          </span>
          <h2 className="text-white text-center font-['SpaceGrotesk-Bold',_sans-serif] text-4xl md:text-5xl lg:text-6xl leading-tight font-bold max-w-4xl">
            DebtPulse-Your Complete Digital Collections OS
          </h2>
          <p className="text-[#f3e8ff] text-center font-normal text-lg md:text-xl leading-relaxed max-w-3xl">
            From DPD tracking to settlement approval, DebtPulse centralizes,
            automates, and optimizes every stage of the recovery lifecycle.
          </p>
        </div>

        {/* Solution Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {solutions.map((item) => (
            <div
              key={item.title}
              className="bg-white/10 rounded-3xl border border-white/20 p-8 flex flex-col gap-8"
              style={{ backdropFilter: "blur(5px)" }}
            >
              <div className="flex flex-col gap-4">
                <div className="bg-white/20 rounded-3xl flex items-center justify-center w-16 h-16 shrink-0">
                  {item.icon}
                </div>
                <h3 className="text-white font-['SpaceGrotesk-Bold',_sans-serif] text-2xl leading-8 font-bold">
                  {item.title}
                </h3>
              </div>
              <ul className="flex flex-col gap-3">
                {item.points.map((point) => (
                  <li key={point} className="flex flex-row gap-2 items-start">
                    <div className="pt-0.5 shrink-0">
                      <CheckIcon />
                    </div>
                    <span className="text-[#f3e8ff] font-normal text-base leading-6">
                      {point}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
